<template>
    <div id="timesheetdetail">
        <nav class="printableNo">
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="openNav()" src="/assets/burger.png" alt="burger" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
            <div class="sideNav" :style="{ width: navWidth + 'px' }">
                <div class="leftNav">
                    <div class="innerNav">
                        <img class="navLogout" v-on:click="openNav()" src="/assets/burgerwhite.png" alt="burger" />
                    </div>
                </div>
                <div v-if="navMenuVisible" class="navsidecontent">
                    <div class="navtitle noborder">
                        Gérer les biens et demandes
                    </div>
                    <div v-on:click="goToNewBuildingPage" class="navsubtitle">
                        Créer un nouveau bien
                    </div>
                    <div v-on:click="goToBuildingPage" class="navsubtitle">
                        Consulter/Modifier les biens et demandes
                    </div>
                    <div class="navtitle">
                        Plannings
                    </div>
                    <div v-on:click="goToPlanningPage" class="navsubtitle">
                        Consulter/Modifier les plannings
                    </div>
                    <div v-on:click="goToTimeSheetPage" class="navsubtitle">
                        Fiches horaires
                    </div>
                    <div class="navtitle">
                        Groupes
                    </div>
                    <div v-on:click="goToNewGroupPage" class="navsubtitle">
                        Ajouter un groupe
                    </div>
                    <div v-on:click="goToAllGroupPage" class="navsubtitle">
                        Voir/Modifier les groupes
                    </div>
                    <div class="navtitle">
                        Utilisateurs
                    </div>
                    <div v-on:click="goToNewUserPage" class="navsubtitle">
                        Ajouter un utilisateur
                    </div>
                    <div v-on:click="goToAllUserPage" class="navsubtitle">
                        Voir/Modifier les utilisateurs
                    </div>
                    <div v-on:click="logout()" class="navtitle logout">
                        Déconnexion
                    </div>
                </div>
            </div>
        </nav>
        <div class="filAriane printableNo">
            <span v-html="filAriane"></span>
        </div>
        <div class="outercircle printableNo">
            <div class="homeName">
                {{Name}}
            </div>
            <div id="circle"></div>
        </div>
        <h1>
            <button v-on:click="backbtn()" class="btnBack printableNo">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
            Fiche horaire mensuelle - {{user.address.firstName + " "+ user.address.lastName}}
        </h1>
        <div class="textline">
            <center>
                Période : {{date}}<br>
                <i v-if="fullMonthBasket<2">{{displayTime(fullMonthTime)}}, dont {{displayTime(fullMonthTimeRemote)}} en déplacement, {{fullMonthBasket}} panier</i>
                <i v-else>{{displayTime(fullMonthTime)}}, dont {{displayTime(fullMonthTimeRemote)}} en déplacement, {{fullMonthBasket}} paniers</i>
                <br>
                <button class="docBtn printableNo" type="button" v-on:click="printButton()">
                    Imprimer
                </button>
            </center>
        </div>
        <div v-if="sortedPlannings.length">
            <div class="notifList" v-for="(item, index) in sortedPlannings" :key="index">
                <button v-on:click="displayYear(index)" class="btnAccordion">
                    <font-awesome-icon v-if="getYear(index)" icon="angle-up" class="printableNo"/>
                    <font-awesome-icon v-else icon="angle-down" class="printableNo"/>
                    &nbsp;&nbsp;{{item.dateWeek}}
                    <span class="btnAccordionRight">
                        {{displayTime(item.duration)+"  (dont  "+displayTime(item.durationRemote)+" en déplacement) - "+item.basket+" panier"}}
                    </span>
                </button>
                <div v-if="!getYear(index)">
                    <div v-for="(itemInq, indexInq) in item.data" :key="indexInq">
                        <div class="divCard">
                            <span class="spanCard">
                                <b>{{ itemInq.fullhour + "  ("+ displayTime(itemInq.duration)+")" + "\t\t\t-\t\t\t"+itemInq.activityType + "  -  "+getPlanningAddress(itemInq.addressStr)}}</b>
                            </span>
                            <!-- <button class="btnCard" v-on:click="goToTimeSheetPage()"><font-awesome-icon icon="chevron-right" /></button> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <span class="btnAccordion btnAccordionNone">
            Aucune fiche horaire disponible
            </span>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'Timesheetdetail',
        data() {
            return {
                user : {address:{}},
                date: "",
                Name:"client",
                Techs:[],
                sortedPlannings:[],
                isDateHide: [],
                navWidth:0,
                navMenuVisible:false,
                filAriane: "",
                fullMonthTime: 0,
                fullMonthBasket:0,
                fullMonthTimeRemote: 0,
                plannings: []
            };
        },
        methods:{
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('historyQuery');
                this.$cookie.delete('history');
                this.$router.replace({ name: "login" });
            },
            openNav(){
                 
                if(!this.navWidth){
                    this.navWidth = 300;
                }
                else{
                    this.navWidth = 0;
                }
                
                var vm = this;
                setTimeout(function(){
                    vm.navMenuVisible = !vm.navMenuVisible;
                }, 100);
            },
            displayTime(d){
                var h = Math.floor(d / 3600);
                var m = Math.floor(d % 3600 / 60);

                var hDisplay = h + "h ";
                var mDisplay = m + "min ";
                return hDisplay + mDisplay; 
            },
            goToBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "buildinglist"});
            },
            goToNewBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newbuilding"});
            },
            goToPlanningPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "planningadmin"});
            },
            goToTimeSheetPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "timesheet"});
            },
            goToAllUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "alluser"});
            },
            goToNewUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newuser"});
            },
            goToAllGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "allgroup"});
            },
            goToNewGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newgroup"});
            },
            goToModifyIntervention(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "modifyintervention", query:{name: this.$route.query.name}});
            },
            refresh(){
                location.reload();
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$cookie.set('history', "");
                this.$cookie.set('historyQuery', "");
                this.$router.replace({ name: "adminhome" });
            },	
            backbtn(){

                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);
                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);
                
                this.$cookie.set('history', JSON.stringify(arrHist.slice(0, -1)));
                this.$cookie.set('historyQuery', JSON.stringify(arrQuery.slice(0, -1)));

                if(arrHist.length){
                    if(arrQuery[arrQuery.length-1] !== "" && arrQuery[arrQuery.length-1] !== "undefined"){
                        this.$router.replace({ name: arrHist[arrHist.length-1], query: {name: arrQuery[arrQuery.length-1]} });
                    }
                    else{
                        this.$router.replace({ name: arrHist[arrHist.length-1] });
                    }
                }
                else{
                    this.$cookie.set('currentAriane', "");
                    this.$router.replace({ name: "adminhome" });
                }
            },
            getCookies: function() {
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || (this.$cookie.get('role') !== "admin" && this.$cookie.get('role') !== "technicien bureau") || !this.$route.query.id || !this.$route.query.name){
                    this.logout();
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getUserData();
                }
            },
            displayYear(i){
                var state = !this.isDateHide[i];
                this.isDateHide.splice(i, 1);
                this.isDateHide.splice(i, 0,state);
            },
            getPlanningAddress(a){
                if(a){
                    return a;
                }
                else{
                    return "Emplacement inconnu";
                }
            },
            printButton(){
                var locIsDateHide = []
                for(var i=0; i<this.isDateHide.length; i++){
                    locIsDateHide.push(this.isDateHide[i]);
                }
                
                for(var j=0; j<this.isDateHide.length; j++){
                    this.isDateHide.splice(j, 1);
                    this.isDateHide.splice(j, 0,false);
                }
                var vm = this;
                setTimeout(function(){
                    window.print();
                    setTimeout(function(){
                        for(var k=0; k<vm.isDateHide.length; k++){
                            vm.isDateHide.splice(k, 1);
                            vm.isDateHide.splice(k, 0,locIsDateHide[k]);
                        }
                    }, 300);
                }, 300);
            },
            getYear(i){
                return this.isDateHide[i];
            },
            sortingPlanning(){

                this.sortedPlannings = [];

                for(var i=0; i<this.plannings.length; i++){
                    if(this.user.idWeweb === this.plannings[i].user.idWeweb && (this.plannings[i].endTimestamp - this.plannings[i].startTimestamp < 86400)){

                        var n = new Date(this.plannings[i].startTimestamp*1000);
                        
                        var hours =  "0" +n.getHours();
                        var minutes = "0" + n.getMinutes();
                        var day = "0" + n.getDate();
                        var month = "0" + (n.getMonth()+1);               

                        var capsMonth = n.toLocaleString(window.navigator.language, {weekday: 'long'}).charAt(0).toUpperCase() + n.toLocaleString(window.navigator.language, {weekday: 'long'}).slice(1);

                        this.plannings[i].fulldate = day.substr(-2) + '/' + month.substr(-2) + " " + capsMonth;
                        
                        var m = new Date(this.plannings[i].endTimestamp*1000);
                        var hoursEnd =  "0" +m.getHours();
                        var minutesEnd = "0" + m.getMinutes();

                        this.plannings[i].fullhour = hours.substr(-2) + 'h' + minutes.substr(-2) + " - " + hoursEnd.substr(-2) + 'h' + minutesEnd.substr(-2);
                        
                        this.fullMonthTime = this.fullMonthTime + (this.plannings[i].endTimestamp - this.plannings[i].startTimestamp);

                        this.plannings[i].duration = this.plannings[i].endTimestamp - this.plannings[i].startTimestamp;
                        
                        var durationRemote = 0;

                        if(this.plannings[i].isRemote){
                            this.fullMonthTimeRemote = this.fullMonthTimeRemote + (this.plannings[i].endTimestamp - this.plannings[i].startTimestamp);
                            durationRemote = this.plannings[i].duration;
                        }

                        var dateAlreadyExist = false;

                        for(var j=0; j<this.sortedPlannings.length; j++){
                            if(this.sortedPlannings[j].dateWeek === this.plannings[i].fulldate){
                                dateAlreadyExist = true;
                                if(this.plannings[i].startTimestamp > this.sortedPlannings[j].data[0].startTimestamp){
                                    this.sortedPlannings[j].data.unshift(this.plannings[i]);
                                    this.sortedPlannings[j].duration = this.sortedPlannings[j].duration + this.plannings[i].duration;
                                    this.sortedPlannings[j].durationRemote = this.sortedPlannings[j].durationRemote + durationRemote;
                                }
                                else{
                                    this.sortedPlannings[j].data.push(this.plannings[i]);
                                    this.sortedPlannings[j].duration = this.sortedPlannings[j].duration + this.plannings[i].duration;
                                    this.sortedPlannings[j].durationRemote = this.sortedPlannings[j].durationRemote + durationRemote;
                                }
                            }
                        }
                        if(!dateAlreadyExist){
                            if(this.sortedPlannings.length){
                                if(this.sortedPlannings[0].data[0].startTimestamp < this.plannings[i].startTimestamp){
                                    this.isDateHide.unshift(false);
                                    this.sortedPlannings.unshift({dateWeek:this.plannings[i].fulldate, data:[this.plannings[i]], duration:this.plannings[i].duration, durationRemote:durationRemote });
                                }
                                else{
                                    this.isDateHide.push(false);
                                    this.sortedPlannings.push({dateWeek:this.plannings[i].fulldate, data:[this.plannings[i]], duration:this.plannings[i].duration, durationRemote:durationRemote});
                                }
                            }
                            else{
                                this.sortedPlannings.push({dateWeek:this.plannings[i].fulldate, data:[this.plannings[i]], duration:this.plannings[i].duration, durationRemote:durationRemote});
                            }
                        }
                        
                    }
                }

                for(var k=0; k<this.sortedPlannings.length; k++){
                    if(this.sortedPlannings[k].duration > 17999){
                        this.fullMonthBasket = this.fullMonthBasket+1;
                        this.sortedPlannings[k].basket = 1;   
                    }
                    else{
                        this.sortedPlannings[k].basket = 0;  
                    }
                }
            },
            async getPlanning(start, end){
                var response = await axios.get('https://so.gaviota.fr/api/building/final/planning/'+start+"/"+end);
                if(response.data.plannings){
                    this.plannings = [];
                    this.plannings = response.data.plannings;
                    this.sortingPlanning()
                }                            
            },
            async getUserData(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/userdata/'+this.$route.query.id);
                if(response.data.user){
                    this.user = response.data.user

                    var dateMonth = new Date(this.$route.query.name*1000);
                    var firstDayOfMonth = new Date(dateMonth.getFullYear(), dateMonth.getMonth(), 0);
                    var lastDayOfMonth = new Date(dateMonth.getFullYear(), dateMonth.getMonth()+1, 0);
                    this.date = dateMonth.toLocaleString(window.navigator.language, { month: 'long' }) + " "+dateMonth.getFullYear() ;
                    this.getPlanning(firstDayOfMonth /1000 |0, lastDayOfMonth/1000 |0);
                }
            }
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #timesheetdetail {
        width: 90%;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 60px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    @media screen and (max-width: 768px) {
        .h1 {
              font-size: 24px;
            }
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }

    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }

    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        background-color: #1ce83e;
        font-size: 30px;
        position: absolute;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .greyBack{
        margin:40px;
        background-color: #E5E5E5;
        color:black;
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        padding: 10px;
        border: 1px solid;
        border-color:#555;
    }
    .divCard{
        vertical-align: middle;
        position: relative;
        background-color: #F0F0F0;
        border-bottom: 2px solid;
        border-color:#1ce83e28;
        padding:10px;
        margin:2px;
    }
    .spanCardtype{
        display:inline-block;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 15px;
        position: absolute;
        left: 16px;
    }
    .spanCardstatus{
        display:inline-block;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 16px;
        position: absolute;
        right: 55px;
    }
    .spanCardtitle{
        display:block;
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
    }
    .btnCard{
        width:20px;
        height: 20px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 20px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .filAriane{
        background-color: #F0F0F0;
        font-family: 'BenchNine', sans-serif;
        padding-top:20px;
        margin-left:-50px;
        margin-bottom:-17px;
        font-size: 17px;
    }		
    .sideNav{
        background-clip: border-box;
        background-color: #FFF;
        background-origin: padding-box;
        box-sizing: border-box;
        background-color: #333;
        display: block;
        height: 100%;
        overflow:auto;
        box-shadow: 8px 0px 6px -6px #999;
        position:fixed;
        top:0;
        left:0;
        z-index:10;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navsidecontent{
        color:white;
        font-family: 'BenchNine', sans-serif;
        margin-top:65px;
        margin-left:30px;
        margin-right:30px;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navtitle{
        margin:10px;
        margin-top:15px;
        padding-top:5px;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        border-top: 1px solid;
        border-color:#eee;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:default;
                              
    }
    .navsubtitle{
        margin:7px;
        font-size: 18px;
        font-weight: 400;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:pointer;
    }
    .navsubtitle:hover{
        color:#999;
    }
    .noborder{
        border:none;
        margin-top:5px;
        padding-top:0px;
    }
    .logout{
        padding-top:50px;
        cursor:pointer;
    }
    
	/* width */
	::-webkit-scrollbar {
		width: 6px;
	}
	
	/* Track */
	::-webkit-scrollbar-track {
		background: #ddd; 
	}
	
	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #888; 
		border-radius: 3px;
	}
	
	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}
    .editBtnDiv{
        position:relative;
    }
    .editBtn{
        width:30px;
        height: 30px;
        position:absolute;
        bottom:10px;
        right:10px;
        cursor:pointer;
    }
    .textline{
        padding:5px;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
    }
    .textLen{
        width:120px;
        display: inline-block;
    }
    .select{
        width: calc(100% - (100px + 40px));
        margin-bottom:10px;
    }
    .inputTxt{
        width:calc(100% - (100px + 50px));
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
        background-color: #F7F7F7;
        border: 1px solid #bbb;
        padding-left:5px;
        margin-left:5px;
        display: inline-block;
    }
   .btnAccordion{
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
        border:none;
        cursor: pointer;
        width: calc(100% - (5px + 5px));
        display: inline-block;
        text-align: left;
        background-color: #FFF;
        margin: 5px;
    }

   .btnAccordionRight{
        cursor: default;
        margin: 5px;
        float:right;
    }    
    .notifList{
        margin-bottom: 10px;
    }
    
    .btnAccordionNone{
        cursor: default;
        padding-left:15px;
        -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
        -moz-box-sizing: border-box;    /* Firefox, other Gecko */
        box-sizing: border-box;         /* Opera/IE 8+ */
    }
    .spanCard{
        display:inline-block;
        padding-left:5px;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 17px;
    }
    .docBtn{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: inline-block;
        border:none;
        color:#1ce83e;
        font-size: 18px;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        width: 200px;
        margin:15px;
    }
    .center{
        display: inline-block;
    }
    
    @media print {
        .printableNo {display:none;}
    }
    @page { size: auto; margin: 0mm; }
</style>